/* global L, document */

import {
  createSellTimberPlacedMarkerLeafletIcon,
  DEFAULT_SELL_TIMBER_MARKER_ICON
} from './sellTimberMarkerIcons';

const SELL_TIMBER_MARKER_TT_STYLE_ID = 'auction-placed-map-marker-tt';

/** Permanent name labels on auction map (same styling as Sell Timber wizard). */
export function ensureSellTimberMarkerTooltipStyles() {
  if (typeof document === 'undefined' || document.getElementById(SELL_TIMBER_MARKER_TT_STYLE_ID)) {
    return;
  }
  const s = document.createElement('style');
  s.id = SELL_TIMBER_MARKER_TT_STYLE_ID;
  s.textContent =
    '.leaflet-tooltip.st-sell-timber-marker-name-tt{background:#fff;border:1px solid #b8b8b8;border-radius:4px;color:#1a1a1a;box-shadow:0 1px 3px rgba(0,0,0,0.12);font:11px/1.2 system-ui,-apple-system,sans-serif;padding:3px 7px;white-space:nowrap;max-width:200px;overflow:hidden;text-overflow:ellipsis;}';
  document.head.appendChild(s);
}

/**
 * @param {Array<{ lat?: number, lng?: number, icon?: string, name?: string }>} placedList
 * @param {L.FeatureGroup} featureGroup
 * @param {{ tooltipClassName?: string }} [options]
 */
export function addPlacedMarkersToFeatureGroup(placedList, featureGroup, options = {}) {
  if (!Array.isArray(placedList) || !featureGroup || typeof L === 'undefined') {
    return;
  }
  const tooltipClassName = options.tooltipClassName ?? 'st-sell-timber-marker-name-tt';
  ensureSellTimberMarkerTooltipStyles();

  placedList.forEach((m) => {
    const lat = Number(m && m.lat);
    const lng = Number(m && m.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    const ico =
      createSellTimberPlacedMarkerLeafletIcon(m && m.icon) ||
      createSellTimberPlacedMarkerLeafletIcon(DEFAULT_SELL_TIMBER_MARKER_ICON);
    const ll = L.latLng(lat, lng);
    const mk = L.marker(ll, {
      icon: ico,
      riseOnHover: true,
      type: 'marker'
    });
    const label = m && m.name != null ? String(m.name).trim() : '';
    if (label) {
      mk.bindTooltip(label, {
        permanent: true,
        direction: 'top',
        className: tooltipClassName,
        offset: [0, -38]
      });
    }
    featureGroup.addLayer(mk);
  });
}
